import Preact from 'preact';
import * as U from '../../data/url';
import { SxProps } from '@mui/system';
import { pipe } from 'fp-ts/lib/function';
import { ViewInArDrawer, sizing } from '@dora/components';
import { AsyncResult } from '../hooks/useAsync';
import { TranslateContext } from '@denysvuika/preact-translate';
import { useContext } from 'preact/hooks';

export interface Props {
    platform: sizing.Platform;
    portrait: boolean;
    open: boolean;
    sx?: SxProps;
    // in px
    paddingTop?: number;
    onClose: () => void;
    sharingUrlRequest: AsyncResult<string | undefined>;
    img: string;
}

export const Component = (props: Props) => {
    const { t } = useContext(TranslateContext);
    const qrUrl = props.sharingUrlRequest.result
        ? pipe(props.sharingUrlRequest.result, U.url, U.fromQrCode, U.toString)
        : undefined;

    return (
        <ViewInArDrawer.Component
            url={qrUrl}
            sharingUrlError={props.sharingUrlRequest.error}
            platform={props.platform}
            portrait={props.portrait}
            open={props.open}
            sx={props.sx}
            paddingTop={props.paddingTop}
            onClose={props.onClose}
            img={props.img}
            arHeader={t('i18n.global.qrCodeDialogHeader')}
            qrLoading={t('i18n.global.qrLoading')}
            arDrawerTitle={t('i18n.global.arDrawerHeader')}
            errorHeading={t('i18n.global.qrErrorHeading')}
            errorMessage={t('i18n.global.qrErrorMessage')}
        />
    );
};
